export type FriendlyMeaningsType = {
  [key: string]: string;
};

export type MeaningsType = {
  [key: string]: string;
};

export const EQUIPMENT_MAKE = {
  avalon: 'Avalon',
  envy: 'Envy',
};

interface Entry {
  description: string;
  name: string;
  dType: string;
  unit: string | null;
  meanings: MeaningsType | null;
  friendlyMeanings: FriendlyMeaningsType | null;
  options?: string[];
  range?: {
    min: number;
    max: number;
  };
}

export interface PointsProps {
  address: string;
  entry: Entry;
  value: number;
  scaledValue: number;
  unit: string;
  readOnly: boolean;
  protocol: string;
  block: 'fixed' | 'repeating';
  modelId?: number;
  point: string;
}

interface Theme {
  sections: {
    [key: string]: {
      description: string;
      points: PointsProps[];
    };
  };
  name: string;
}

export interface ThemesProps {
  [key: string]: Theme;
}

export interface DataProps {
  age: string;
  themes: ThemesProps;
}
